module.exports = __webpack_public_path__ + "static/media/contestacao.a047c51b.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/contestacao.png
// module id = 47
// module chunks = 0